import React from 'react';
import { NavLink } from 'react-router-dom';
import './projectInactive.css';

function ProjectInactive() {
    return (
        <section className="inactive-project-container flex">
            <article className="inactive-content flex">
                <div className="image-container">
                    <svg viewBox="0 0 200 200" className="oops-image">
                        <circle cx="100" cy="100" r="90" fill="#8A99F5" />
                        <text x="50%" y="50%" textAnchor="middle" fill="#ffffff" fontSize="40" fontFamily="Montserrat" fontWeight="bold">
                            Oops!
                        </text>
                    </svg>
                </div>
                <h2>Proyecto Inactivo</h2>
                <p>Tu proyecto se encuentra actualmente inactivo.</p>
                <p>Solo tienes acceso a los siguientes informes:</p>
                <div className="reports-links flex">
                    <NavLink to="/finanzas/ejecucionPME" className="report-link">
                        Informe PME
                    </NavLink>
                    <NavLink to="/finanzas/presupuesto" className="report-link">
                        Informe Presupuesto
                    </NavLink>
                </div>
            </article>
        </section>
    );
}

export default ProjectInactive;